const VERSION = {
  frontend: '7.4.3',
};

export default VERSION;
